import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useValidator } from '@/libs/validator';
import { computed, watch } from 'vue';

interface Emits {
  (type: 'hasErrorUpdated', event: boolean): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Tab',
  emits: ["hasErrorUpdated"],
  setup(__props, { emit }: { emit: ({
  (type: 'hasErrorUpdated', event: boolean): void;
}), expose: any, slots: any, attrs: any }) {



const validator = useValidator();
const hasErrors = computed(() => {
  return validator.getErrors().value.length > 0;
});
watch(hasErrors, (value) => {
  emit('hasErrorUpdated', value);
}, {
  immediate: true,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})